// extracted by mini-css-extract-plugin
module.exports = {"headline":"az_ljb","circularPage":"az_mjb"};